/* eslint-disable */
import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import Qs from 'qs';
/** 代替IE無法使用find */
const IEFind = (items: any, key: number) => {
  const result = items.filter((item: any) => item.p4_node_id === key);
  if (result.length) { return result[0]; }
  return null;
};

@Component
export default class Permission extends Vue {
  @Prop()
  contentSize!: object;

  private node: any = null;

  private role: any = [];

  private roleList: any = [];

  private checkedData: any = [];

  private loading: boolean = false;

  private dialogRole: boolean = false;

  @Watch('role')
  onChildChanged(val: []) {
    this.$nextTick(() => {
      const ref: any = this.$refs.modifyTable;
      ref.doLayout();
    });
  }

  handleChange(e: any, index: any) {
    if (e.target.checked) {
      Object.keys(this.node).forEach((item) => {
        this.$set(this.checkedData[this.node[item].p4_node_id], index, [4, 8, 2, 1]);
      });
    } else {
      Object.keys(this.node).forEach((item) => {
        this.$set(this.checkedData[this.node[item].p4_node_id], index, []);
      });
    }
  }

  /**
   * 尋找爸爸之旅
   */
  findPid(pidArr: Array<Number>, PidData: any) {
    // 拿當前nodeID從樹尋找
    if (PidData.p4_node_pid !== null) {
      pidArr.push(PidData.p4_node_pid);
      const PidData2 = this.node.filter(
        (item: any) => item.p4_node_id === PidData.p4_node_pid,
      );
      if (PidData2.length && typeof PidData2[0] === 'object') {
        this.findPid(pidArr, PidData2[0]);
      }
    }
  }

  /**
   * 尋找孩子之旅
   */
  findChid(chidArr: Array<Number>, Data: any) {
    // eslint-disable-next-line no-restricted-syntax
    for (const item of Data.subs) {
      chidArr.push(item.p4_node_id);
      if (item.subs) {
        this.findChid(chidArr, item);
      }
    }
  }

  /**
   * read
   */
  public read(nodeID: any, roleId: any) {
    const itemData = this.checkedData[nodeID][roleId];
    // 添加值上去
    if (itemData[0]) {
      const chidArr: any = [];
      const Data = IEFind(this.node, nodeID);
      this.$set(itemData, 0, undefined);
      this.$set(itemData, 1, undefined);
      this.$set(itemData, 2, undefined);
      this.$set(itemData, 3, undefined);

      this.findChid(chidArr, Data);
      // eslint-disable-next-line no-restricted-syntax
      for (const item of chidArr) {
        this.$set(this.checkedData[item][roleId], 0, undefined);
        this.$set(this.checkedData[item][roleId], 1, undefined);
        this.$set(this.checkedData[item][roleId], 2, undefined);
        this.$set(this.checkedData[item][roleId], 3, undefined);
      }
    } else {
      this.$set(itemData, 0, 4);
      const pidArr: any = [];
      const chidArr: any = [];
      const PidData = IEFind(this.node, nodeID);
      this.findPid(pidArr, PidData);
      this.findChid(chidArr, PidData);
      const concat = pidArr.concat(chidArr);
      // eslint-disable-next-line no-restricted-syntax
      for (const item of concat) {
        this.$set(this.checkedData[item][roleId], 0, 4);
      }
    }
  }

  /**
   * create
   */
  public create(nodeID: any, roleId: any) {
    const itemData = this.checkedData[nodeID][roleId];
    if (itemData[1]) {
      this.$set(itemData, 1, undefined);
      const chidArr: any = [];
      const Data = IEFind(this.node, nodeID);
      this.findChid(chidArr, Data);
      // eslint-disable-next-line no-restricted-syntax
      for (const item of chidArr) {
        this.$set(this.checkedData[item][roleId], 1, undefined);
      }
    } else {
      this.$set(itemData, 0, 4);
      this.$set(itemData, 1, 8);
      const pidArr: any = [];
      const chidArr: any = [];
      const PidData = IEFind(this.node, nodeID);
      this.findPid(pidArr, PidData);
      this.findChid(chidArr, PidData);
      const concat = pidArr.concat(chidArr);
      // eslint-disable-next-line no-restricted-syntax
      for (const item of concat) {
        this.$set(this.checkedData[item][roleId], 0, 4);
        this.$set(this.checkedData[item][roleId], 1, 8);
      }
    }
  }

  /**
   * modify
   */
  public modify(nodeID: any, roleId: any) {
    const itemData = this.checkedData[nodeID][roleId];
    if (itemData[2]) {
      this.$set(itemData, 2, undefined);
      const chidArr: any = [];
      const Data = IEFind(this.node, nodeID);
      this.findChid(chidArr, Data);
      // eslint-disable-next-line no-restricted-syntax
      for (const item of chidArr) {
        this.$set(this.checkedData[item][roleId], 2, undefined);
      }
    } else {
      this.$set(itemData, 0, 4);
      this.$set(itemData, 2, 2);
      const pidArr: any = [];
      const chidArr: any = [];
      const PidData = IEFind(this.node, nodeID);
      this.findPid(pidArr, PidData);
      this.findChid(chidArr, PidData);
      const concat = pidArr.concat(chidArr);
      // eslint-disable-next-line no-restricted-syntax
      for (const item of concat) {
        this.$set(this.checkedData[item][roleId], 0, 4);
        this.$set(this.checkedData[item][roleId], 2, 2);
      }
    }
  }

  /**
   * Delete
   */
  public Delete(nodeID: any, roleId: any) {
    const itemData = this.checkedData[nodeID][roleId];
    if (itemData[3]) {
      this.$set(itemData, 3, undefined);
      const chidArr: any = [];
      const Data = IEFind(this.node, nodeID);
      this.findChid(chidArr, Data);
      // eslint-disable-next-line no-restricted-syntax
      for (const item of chidArr) {
        this.$set(this.checkedData[item][roleId], 3, undefined);
      }
    } else {
      this.$set(itemData, 0, 4);
      this.$set(itemData, 3, 1);
      const pidArr: any = [];
      const chidArr: any = [];
      const PidData = IEFind(this.node, nodeID);
      this.findPid(pidArr, PidData);
      this.findChid(chidArr, PidData);
      const concat = pidArr.concat(chidArr);
      // eslint-disable-next-line no-restricted-syntax
      for (const item of concat) {
        this.$set(this.checkedData[item][roleId], 0, 4);
        this.$set(this.checkedData[item][roleId], 3, 1);
      }
    }
  }

  action(node: any, parentId: number, layer: number = 1) {
    const push = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const item of node) {
      if (item != null && item.p4_node_pid === parentId) {
        item.layer = layer;
        item.subs = this.action(
          node,
          item.p4_node_id,
          layer + 1,
        );
        push.push(item);
      }
    }
    return push;
  }

  // 開始將扁平化路由變成樹
  // eslint-disable-next-line class-methods-use-this
  private start(node: any) {
    const tree = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const item of node) {
      if (!item.p4_node_pid) {
        item.subs = this.action(node, item.p4_node_id);
        item.layer = 0;
        tree.push(item);
      }
    }
    return tree;
  }

  /**
   * 解樹
   */
  public reNode(node: any, nodeTree: any) {
    // eslint-disable-next-line no-restricted-syntax
    for (const item of nodeTree) {
      node.push(item);
      if (item.subs) {
        item.layer2 = item.subs.length === 0 ? -1 : null;
        this.reNode(node, item.subs);
      }
    }
  }

  /**
   * 整理角色 把設定階層名稱加上去
   */
  private roleList_f(res: any) {
    // const roleList = res.role.filter((r: any) => r.p5_role_status === '3');
    const roleList = res.role;
    return roleList;
  }

  /**
   * getPermission
   */
  public async getPermission() {
    this.loading = true;
    const res = await this.$http.get('permission/access/info');
    this.roleList = this.roleList_f(res.data.response);
    // 將Node變成樹
    const nodeTree: any = this.start(res.data.response.node);
    // 在將樹解呈扁平化
    const nodeData: any = [];
    this.reNode(nodeData, nodeTree);
    this.node = nodeData;
    // 建立一個多維陣列 第一維:樹的ID 第二維:角色ID
    // eslint-disable-next-line no-restricted-syntax
    for (const nodeKey of this.node) {
      this.$set(this.checkedData, nodeKey.p4_node_id, []);
      // eslint-disable-next-line no-restricted-syntax
      for (const roleKey of this.roleList) {
        this.$set(
          this.checkedData[nodeKey.p4_node_id],
          roleKey.p5_role_id,
          [],
        );
      }
    }
    // 取得以設定的資料
    const roleNode = res.data.response.role_node;
    // eslint-disable-next-line no-restricted-syntax
    for (const roleId in roleNode) {
      for (const item in roleNode[roleId]) {
        const CRUD: any = [];

        // eslint-disable-next-line no-bitwise
        const info = roleNode[roleId][item] & 0x4 ? roleNode[roleId][item] & 0x4 : undefined;
        this.$set(CRUD, 0, info);
        // eslint-disable-next-line no-bitwise
        const add = roleNode[roleId][item] & 0x8 ? roleNode[roleId][item] & 0x8 : undefined;
        this.$set(CRUD, 1, add);
        // eslint-disable-next-line no-bitwise
        const edit = roleNode[roleId][item] & 0x2 ? roleNode[roleId][item] & 0x2 : undefined;
        this.$set(CRUD, 2, edit);
        // eslint-disable-next-line no-bitwise
        const del = roleNode[roleId][item] & 0x1 ? roleNode[roleId][item] & 0x1 : undefined;

        this.$set(CRUD, 3, del);


        this.$set(
          this.checkedData[item],
          roleId,
          CRUD,
        );
      }


    }
    this.loading = false;
  }

  public async roletest() {
    this.loading = true;

    const that = this;
    const postData: any = [];
    // eslint-disable-next-line no-restricted-syntax
    for (const key in this.checkedData) {
      if (this.checkedData[key].length !== 0) {
        // eslint-disable-next-line no-restricted-syntax
        for (const innerKey in this.checkedData[key]) {
          if (
            typeof this.checkedData[key][innerKey] !== 'undefined'
            && this.checkedData[key][innerKey].length > 0
          ) {
            if (postData[key] === undefined) {
              postData[key] = [];
            }
            let CRUD = 0;
            // eslint-disable-next-line no-restricted-syntax
            for (const CRUDKey of this.checkedData[key][innerKey]) {
              if (CRUDKey !== undefined) {
                CRUD += CRUDKey;
              }
            }

            postData[key][innerKey] = CRUD;
          }
        }
      }
    }

    // eslint-disable-next-line camelcase
    const set_data = postData;
    const res = await this.$http.put(
      'permission/access/doModify',
      Qs.stringify({
        set_data,
      }),
    );
    this.loading = false;
  }

  mounted() {
    this.getPermission();
    this.$bus.$on('info', (params: any) => {
      this.$router.push({ name: 'access-info' });
    });
    this.$bus.$on('save', (params: any) => {
      this.roletest();
    });
    this.$bus.$on('role', () => {
      this.dialogRole = true;
    });
  }

  created() {
    this.$store.dispatch('setBread', {
      href: 'permission/access/modify',
      label: this.$t('Theme.modify'),
    });
  }
}
